import React from "react";
import { FaGem, FaUsers, FaLightbulb, FaHandshake, FaCircleCheck } from "react-icons/fa6";
import { Container, H2_SIZE, H3_SIZE } from "../home/ui";

// Why-choose artwork (developer at a laptop with code / chart / gear tiles). File: public/img/about-why.jpg
// (cropped from the design mockup; swap in a high-res export when available).
const whyImg = "/img/about-why1.jpg";

const values = [
  { icon: FaGem, title: "Quality", text: "We deliver high-quality solutions that make a difference.", tone: "bg-[#E3EDFF] text-[#2563EB]" },
  { icon: FaUsers, title: "Client Success", text: "Your goals are our goals. We grow together.", tone: "bg-[#DFF7EC] text-[#10B981]" },
  { icon: FaLightbulb, title: "Innovation", text: "We embrace new technologies to build better solutions.", tone: "bg-[#EEE6FF] text-[#7C3AED]" },
  { icon: FaHandshake, title: "Integrity", text: "We believe in transparent communication and long-term relationships.", tone: "bg-[#FFEDD5] text-[#F97316]" },
];

const reasons = [
  "Experienced and skilled team",
  "End-to-end development support",
  "On-time delivery and transparent process",
  "Focus on your business growth",
  "Long-term partnership approach",
];

const Pill = ({ children }) => (
  <span className="inline-block rounded-full bg-[#E3EDFF] px-[14px] py-[5px] text-[12px] font-semibold uppercase tracking-[0.04em] text-[#1E4DFF]">
    {children}
  </span>
);

const fadeX = "linear-gradient(to right, transparent 0%, #000 8%, #000 94%, transparent 100%)";
const fadeY = "linear-gradient(to bottom, transparent 0%, #000 6%, #000 94%, transparent 100%)";
const edgeFade = {
  WebkitMaskImage: `${fadeX}, ${fadeY}`,
  WebkitMaskComposite: "source-in",
  maskImage: `${fadeX}, ${fadeY}`,
  maskComposite: "intersect",
};

const AboutValues = () => (
  <>
    <section className="bg-gradient-to-b from-[#F7F9FE] to-white py-[48px] lg:py-[68px]">
      <Container className="max-w-[1200px]">
        <div className="text-center">
          <Pill>Our Values</Pill>
          <h2 className={`mt-[12px] font-extrabold tracking-tight text-[#0B1A4A] ${H2_SIZE}`}>What Drives Us</h2>
        </div>

        <div className="m-swipe mt-[32px] grid gap-[20px] sm:grid-cols-2 lg:grid-cols-4">
          {values.map((v) => (
            <div
              key={v.title}
              className="flex flex-col items-center rounded-[18px] bg-white px-[22px] py-[28px] text-center shadow-[0_14px_36px_-24px_rgba(40,60,140,0.35)] transition hover:-translate-y-1"
            >
              <span className={`inline-flex h-[64px] w-[64px] items-center justify-center rounded-full text-[26px] ${v.tone}`}>
                <v.icon />
              </span>
              <h3 className={`mt-[16px] font-bold text-[#0B1A4A] ${H3_SIZE}`}>{v.title}</h3>
              <p className="mt-[8px] max-w-[230px] text-[14px] leading-[1.55] text-slate-600">{v.text}</p>
            </div>
          ))}
        </div>
      </Container>
    </section>

    <section className="bg-gradient-to-r from-[#F6F9FF] via-[#F9FBFF] to-[#EEF3FE] py-[48px] lg:py-[68px]">
      <Container className="max-w-[1200px]">
        <div className="grid items-center gap-[32px] lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] lg:gap-[48px]">
          <div>
            <Pill>Why Choose Us</Pill>
            <h2 className={`mt-[14px] font-extrabold tracking-tight text-[#0B1A4A] ${H2_SIZE}`}>
              More Than Just a
              {" "}<br />
              Development Partner
            </h2>
            <ul className="mt-[22px] space-y-[14px]">
              {reasons.map((r) => (
                <li key={r} className="flex items-center gap-[12px] text-[15.5px] text-slate-700">
                  <FaCircleCheck className="shrink-0 text-[18px] text-[#1E6BFF]" />
                  {r}
                </li>
              ))}
            </ul>
          </div>

          <img
            src={whyImg}
            alt="Developer working on a laptop surrounded by code and analytics tiles"
            className="h-auto w-full select-none object-contain"
            style={edgeFade}
          />
        </div>
      </Container>
    </section>
  </>
);

export default AboutValues;
